/**
 * Static blog metadata (matches routes /blog/:id). Titles and bodies come from i18n: blog.post{n}.*
 */
export const BLOG_POSTS = [
    { id: 1, category: 'recipes', authorRole: 'kitchen', date: '2024-01-15', image: 'https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=800&q=80' },
    { id: 2, category: 'tips', authorRole: 'team', date: '2024-01-10', image: 'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=800&q=80' },
    { id: 3, category: 'news', authorRole: 'kitchen', date: '2024-01-05', image: 'https://images.unsplash.com/photo-1490645935967-10de6ba17061?w=800&q=80' },
    { id: 4, category: 'recipes', authorRole: 'team', date: '2024-02-01', image: 'https://images.unsplash.com/photo-1556910103-1c02745aae4d?w=800&q=80' },
    { id: 5, category: 'tips', authorRole: 'kitchen', date: '2024-02-10', image: 'https://images.unsplash.com/photo-1547592180-85f173990554?w=800&q=80' },
    { id: 6, category: 'news', authorRole: 'team', date: '2024-02-15', image: 'https://images.unsplash.com/photo-1567620905732-2d1ec7ab7445?w=800&q=80' },
    { id: 7, category: 'recipes', authorRole: 'kitchen', date: '2024-03-01', image: 'https://images.unsplash.com/photo-1512621776951-a57141f2eefd?w=800&q=80' },
    { id: 8, category: 'tips', authorRole: 'team', date: '2024-03-10', image: 'https://images.unsplash.com/photo-1546069901-ba9599a7e63c?w=800&q=80' },
    { id: 9, category: 'news', authorRole: 'kitchen', date: '2024-03-15', image: 'https://images.unsplash.com/photo-1476224203421-9ac39bcb3327?w=800&q=80' },
];

export function getBlogPostById(id) {
    const num = parseInt(id, 10);
    if (Number.isNaN(num) || num < 1) return null;
    return BLOG_POSTS.find((p) => p.id === num) ?? null;
}

/** Prefer same category, then fill with other posts. */
export function getRelatedPosts(currentId, limit = 2) {
    const current = getBlogPostById(currentId);
    if (!current) return [];
    const others = BLOG_POSTS.filter((p) => p.id !== currentId);
    const sameCategory = others.filter((p) => p.category === current.category);
    const otherCategory = others.filter((p) => p.category !== current.category);
    return [...sameCategory, ...otherCategory].slice(0, limit);
}

export function detailImageUrl(postId, width = 1200) {
    const post = getBlogPostById(postId);
    if (!post?.image) return '';
    try {
        const u = new URL(post.image);
        u.searchParams.set('w', String(width));
        return u.toString();
    } catch {
        return post.image;
    }
}
